//tipos
import { GetterTree } from "vuex";
import { State } from "@/typings/store";
import { StateCondicionesDivisiones } from "@/typings/store/plugins/easyFirestore/condicionesDivisiones";

const getters: GetterTree<StateCondicionesDivisiones, State> = {
    get(state) {
        return state.all;
    },
    getArray(state) {
        return Object.values(state.all);
    },
};

const condicionesDivisiones = {
    firestorePath: "dev/v1/condicionesDivisiones",
    firestoreRefType: "collection",
    moduleName: "condicionesDivisiones",
    statePropName: "all",
    namespaced: true,
    serverChange: {
        convertTimestamps: {
            created_at: "%convertTimestamp%", // default
            updated_at: "%convertTimestamp%", // default
        },
    },
    state: {},
    getters,
    mutations: {},
    actions: {},
};

export default condicionesDivisiones;
